const PATH = 'user';

export { PATH };
export default {};
